import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Utils
import { formatCents, isNil } from '@src/shared/src/util/general';

type Props = {
  label: React.ReactNode;
  value: number | undefined;
};

const PolicyMaxPriceRow: React.FC<Props> = ({ label, value }) => {
  const { t } = useTranslation();

  const renderValue = () => {
    if (isNil(value)) {
      return (
        <i className="material-symbols sidebar-travel-policies-fare-icon is--compliant">
          check_circle
        </i>
      );
    }
    if (value === 0) {
      return (
        <i className="material-symbols sidebar-travel-policies-fare-icon is--forbidden">cancel</i>
      );
    }
    return (
      <span className="sidebar-travel-policies-fare-price">
        {t('SearchSideBarTravelPolicies.label.max')} {formatCents(value)}
      </span>
    );
  };

  return (
    <div className="sidebar-travel-policies-fare-row">
      <span className="sidebar-travel-policies-fare-label">{label}</span>
      {renderValue()}
    </div>
  );
};

export default PolicyMaxPriceRow;
